const MarketPlaceSVG = (): JSX.Element => {
  return (
    <svg
      className="stroke marketplace-icon"
      width="26"
      height="21"
      viewBox="0 0 32 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.6 24.6V14.7H1.6C2.5 10.2 6.2 3.4 9.8 2H22.2C25.8 3.4 29.5 10.2 30.4 14.7H28.4V24.6H3.6Z"
        stroke="#545556"
        strokeWidth="2"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <path d="M13.7 6.1H18.3V10.5H13.7V6.1Z" stroke="#545556" strokeWidth="2" strokeLinejoin="round" />
      <path
        d="M8.2 24.6V16.2H23.8V24.6M16 16.2V24.6"
        stroke="#545556"
        strokeWidth="2"
        strokeLinejoin="round"
        strokeLinecap="square"
      />
      <path
        d="M9.7 17.6L14.5 22.9M14.5 17.6L9.7 22.9M17.5 17.6L22.3 22.9M22.3 17.6L17.5 22.9"
        stroke="#545556"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default MarketPlaceSVG;
